import React from 'react';
import {Loading} from '../../grid-dx/loading/loading';
import FormikAutocomplete from './FormikAutocomplete';

///ESTE ES UNICAMENTE PARA COLABORADORES
const FilteredAutocompleteDefault = ({
  lookup,
  keyForFilter,
  formikProps,
  label,
  field,
  fullWidth,
  myLabel,
  showAll,
  disabled,
  allowDisabled,
}: FilteredSelectProps) => {
  const lookupData = lookup.find((x) => x.column === field); /// Cambiando esto
  if (!lookupData) {
    return <Loading />;
  }

  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }

  if (allowDisabled != null) {
    if (formikProps.values[allowDisabled]) {
      disabled = false;
    } else {
      disabled = true;
    }
  }

  let array: any[];
  //si showAll esta en true, significa que si no se aplico ningun filtro anteriormente muestre datos!
  if (!showAll) {
    array = lookupData.values.filter(
      (x: any) =>
        x[keyForFilter] === formikProps.values[keyForFilter] &&
        x.deleted === false,
    );
  } else {
    array = lookupData.values;
    if (
      formikProps.values[keyForFilter] !== 0 &&
      formikProps.values[keyForFilter] !== ''
    ) {
      array = lookupData.values.filter(
        (x: any) =>
          x[keyForFilter] === formikProps.values[keyForFilter] &&
          x.deleted === false,
      );
    }
  }

  return (
    <FormikAutocomplete
      options={array}
      name={field}
      displayValue={lookupData.displayValue}
      keyValue={lookupData.keyValue}
      label={useMyLabel}
      formikProps={formikProps}
      fullWidth={fullWidth}
      disabled={disabled}
    />
  );
};

interface FilteredSelectProps {
  column: string;
  keyForFilter: string;
  lookup: any[];
  formikProps: any;
  type: string;
  label: string;
  field: string;
  fullWidth: boolean;
  myLabel: string;
  showAll: boolean;
  disabled: boolean;
  allowDisabled: string | null;
}

export default FilteredAutocompleteDefault;
